(() => {
  const MEMBERSHIP_SELECTOR = '[data-kk-membership-widget]';

  function setWidgetError(widget, message) {
    const error = widget?.querySelector('[data-kk-membership-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function prepareWidget(widget) {
    const form = widget.closest('form');
    if (!form) return;

    const quantity = document.querySelector(`[name="quantity"][form="${form.id}"]`);
    if (quantity) {
      quantity.value = '1';
      quantity.min = '1';
      quantity.max = '1';
    }

    const appBlock = document.querySelector('.shopify_subscriptions_app_container');
    const appBlockSection = appBlock?.closest('.shopify-section');
    if (appBlockSection && document.querySelector('.is-kk-membership-product')) {
      appBlockSection.hidden = true;
    }

    form.addEventListener(
      'submit',
      (event) => {
        const variantId = new FormData(form).get('id');
        const sellingPlan = new FormData(form).get('selling_plan');

        if (quantity) quantity.value = '1';

        if (!variantId || !sellingPlan) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setWidgetError(widget, 'Please choose your monthly membership plan before continuing.');
          const submit = widget.querySelector('[type="submit"]');
          submit?.removeAttribute('aria-disabled');
          submit?.classList.remove('loading');
          widget.querySelector('.loading__spinner')?.classList.add('hidden');
        } else {
          setWidgetError(widget, '');
        }
      },
      true,
    );
  }

  function init() {
    document.querySelectorAll(MEMBERSHIP_SELECTOR).forEach(prepareWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
